<template>
  <div>
    <div class="whatsapp-float position-fixed" style="bottom: 20px; right: 20px; z-index: 1050" ref="dropdown">
      <button class="btn btn-success rounded-circle p-3" @click="toggleDropdown" style="box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3)">
        <img src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" alt="WhatsApp" style="width: 32px; height: 32px" />
      </button>

      <transition name="fade-slide">
        <div v-if="dropdownVisible" class="dropdown-float">
          <button v-for="contact in contacts" :key="contact.number" class="dropdown-item text-dark" @click="openWhatsApp(contact.number)">
            {{ contact.name }}
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatsappFloatingButton',
  data() {
    return {
      dropdownVisible: false,
      contacts: [
        { name: 'Fale conosco', number: '5516997193933' }
        // { name: 'Suporte 2', number: '5516997330037' }
      ],
      whatsappWindow: null
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible
    },
    openWhatsApp(number) {
      const url = `https://web.whatsapp.com/send?phone=${number}`

      try {
        if (this.whatsappWindow && !this.whatsappWindow.closed) {
          this.whatsappWindow.focus()
          this.whatsappWindow.location.href = url
        } else {
          this.whatsappWindow = window.open(url, 'Atendimento', 'width=800,height=600')
        }
      } catch (error) {
        this.whatsappWindow = window.open(url, 'whatsappWindow', 'width=800,height=600')
      }

      this.dropdownVisible = false
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.dropdownVisible = false
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.8s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

.dropdown-float {
  box-shadow: 0px 0px 10px 0px rgb(8, 110, 4);
  background-color: lightgrey;
  position: absolute;
  bottom: 5px;
  right: 70px;
  min-width: 200px;
  border: none;
  border-radius: 10px;
}
</style>
